(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_9e3df8d"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('minumjek-brand-carousel')) {
    customElements.define(
      'minumjek-brand-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.startFrame = requestAnimationFrame(() => this.setup());
        }

        setup() {
          this.rail = this.querySelector('.spotlight__rail');
          this.viewport = this.querySelector('.spotlight__viewport');
          this.prev = this.querySelector('.spotlight__arrow--prev');
          this.next = this.querySelector('.spotlight__arrow--next');
          this.originals = Array.from(
            this.rail.querySelectorAll('[data-original]')
          );

          this.count = this.originals.length;
          this.index = 0;
          this.hovered = false;
          this.pressed = false;
          this.animating = false;
          this.abort = new AbortController();
          this.mobile = matchMedia('(max-width: 749px)');

          const on = (target, event, handler) => {
            target.addEventListener(event, handler, {
              signal: this.abort.signal
            });
          };

          on(this.prev, 'click', () => this.move(-1));
          on(this.next, 'click', () => this.move(1));

          on(this.viewport, 'pointerenter', event => {
            if (event.pointerType !== 'mouse') return;
            this.hovered = true;
            this.stopTimer();
          });

          on(this.viewport, 'pointerleave', event => {
            if (event.pointerType !== 'mouse') return;
            this.hovered = false;
            this.schedule();
          });

          on(this.viewport, 'focusin', () => this.stopTimer());
          on(this.viewport, 'focusout', () => {
            queueMicrotask(() => {
              if (this.isConnected) this.schedule();
            });
          });

          on(this.rail, 'pointerdown', () => {
            this.pressed = true;
            this.stopTimer();
            clearTimeout(this.settleTimer);
            this.cancelAnimation();
          });

          const release = () => {
            if (!this.pressed) return;
            this.pressed = false;
            this.queueSettle();
          };

          on(window, 'pointerup', release);
          on(window, 'pointercancel', release);

          on(this.rail, 'wheel', () => {
            this.stopTimer();
            this.cancelAnimation();
            this.queueSettle();
          });

          on(this.rail, 'scroll', () => {
            if (this.animating || this.building || this.count < 2) return;
            this.stopTimer();
            this.queueSettle();
          });

          on(this.rail, 'keydown', event => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          });

          on(document, 'visibilitychange', () => this.schedule());
          on(this.mobile, 'change', () => this.build());

          this.resize = new ResizeObserver(() => {
            const width = this.rail.clientWidth;
            if (width === this.lastWidth) return;
            this.lastWidth = width;
            this.build();
          });

          this.resize.observe(this.rail);
          this.build();
        }

        build() {
          this.stopTimer();
          this.cancelAnimation();
          clearTimeout(this.settleTimer);
          this.building = true;

          this.rail.querySelectorAll('[data-copy]').forEach(el => el.remove());
          this.rail.classList.toggle('spotlight__rail--single', this.count < 2);
          this.prev.hidden = this.count < 2;
          this.next.hidden = this.count < 2;

          if (!this.count || !this.rail.clientWidth) {
            this.building = false;
            return;
          }

          const cardWidth = this.originals[0].getBoundingClientRect().width;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;

          this.step = cardWidth + gap;
          this.centerOffset = (this.rail.clientWidth - cardWidth) / 2;

          const image = this.originals[0].querySelector('.spotlight__image');
          this.viewport.style.setProperty(
            '--arrow-top',
            image.getBoundingClientRect().height / 2 + 'px'
          );

          if (this.count < 2) {
            this.building = false;
            return;
          }

          const cycles = Math.ceil(
            (this.rail.clientWidth / this.step + 2) / this.count
          );

          this.copyCount = cycles * this.count;

          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();

          for (let i = 0; i < this.copyCount; i++) {
            before.append(this.copy(this.originals[i % this.count]));
            after.append(this.copy(this.originals[i % this.count]));
          }

          this.rail.prepend(before);
          this.rail.append(after);

          this.index = ((this.index % this.count) + this.count) % this.count;
          this.rail.scrollLeft = this.position(this.index);
          this.building = false;
          this.schedule();
        }

        copy(original) {
          const clone = original.cloneNode(true);
          clone.removeAttribute('data-original');
          clone.setAttribute('data-copy', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, [tabindex]').forEach(el => {
            el.setAttribute('tabindex', '-1');
          });
          return clone;
        }

        position(index) {
          return (this.copyCount + index) * this.step - this.centerOffset;
        }

        nearestIndex() {
          return Math.round(
            (this.rail.scrollLeft + this.centerOffset) / this.step
          ) - this.copyCount;
        }

        move(direction) {
          if (this.count < 2 || this.animating) return;
          this.stopTimer();
          clearTimeout(this.settleTimer);
          this.animateTo(this.nearestIndex() + direction);
        }

        queueSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            if (this.pressed || this.animating || this.count < 2) return;
            this.animateTo(this.nearestIndex());
          }, 160);
        }

        animateTo(index) {
          this.cancelAnimation();
          this.stopTimer();

          const start = this.rail.scrollLeft;
          const end = this.position(index);
          const distance = end - start;
          const duration = Math.max(200, Number(this.dataset.duration) || 500);
          const started = performance.now();

          this.animating = true;

          const finish = () => {
            this.index = ((index % this.count) + this.count) % this.count;
            this.rail.scrollLeft = this.position(this.index);
            this.animationFrame = requestAnimationFrame(() => {
              this.animationFrame = requestAnimationFrame(() => {
                this.animating = false;
                this.schedule();
              });
            });
          };

          if (Math.abs(distance) < 1) {
            finish();
            return;
          }

          const tick = now => {
            const progress = Math.min(1, (now - started) / duration);
            const eased = 1 - Math.pow(1 - progress, 3);

            this.rail.scrollLeft = start + distance * eased;

            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(tick);
            } else {
              finish();
            }
          };

          this.animationFrame = requestAnimationFrame(tick);
        }

        cancelAnimation() {
          cancelAnimationFrame(this.animationFrame);
          this.animating = false;
        }

        stopTimer() {
          clearTimeout(this.autoplayTimer);
        }

        schedule() {
          this.stopTimer();

          const enabled = this.mobile.matches
            ? this.dataset.mobile === 'true'
            : this.dataset.desktop === 'true';

          const focused = this.viewport.contains(document.activeElement);

          if (
            !this.isConnected ||
            !enabled ||
            this.count < 2 ||
            this.hovered ||
            this.pressed ||
            this.animating ||
            focused ||
            document.hidden
          ) return;

          const delay = Math.max(2, Number(this.dataset.interval) || 5) * 1000;

          this.autoplayTimer = setTimeout(() => this.move(1), delay);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.startFrame);
          this.cancelAnimation();
          this.stopTimer();
          clearTimeout(this.settleTimer);
          this.abort?.abort();
          this.resize?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_9e3df8e"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('minumjek-featured-carousel')) {
    customElements.define(
      'minumjek-featured-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.startFrame = requestAnimationFrame(() => this.setup());
        }
        setup() {

          this.rail = this.querySelector('.featured__rail');
          this.viewport = this.querySelector('.featured__viewport');
          this.prev = this.querySelector('.featured__arrow--prev');
          this.next = this.querySelector('.featured__arrow--next');
          this.originals = Array.from(
            this.rail.querySelectorAll('[data-original]')
          );
          this.count = this.originals.length;
          this.index = 0;
          this.hovered = false;
          this.pressed = false;
          this.animating = false;
          this.abort = new AbortController();
          this.mobile = matchMedia('(max-width: 749px)');
          this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
          const on = (target, event, handler) => {
            if (!target) return;
            target.addEventListener(event, handler, {
              signal: this.abort.signal
            });
          };
          on(this.prev, 'click', () => this.move(-1));
          on(this.next, 'click', () => this.move(1));
          on(this.viewport, 'pointerenter', event => {
            if (event.pointerType !== 'mouse') return;
            this.hovered = true;
            this.stopTimer();
          });
          on(this.viewport, 'pointerleave', event => {
            if (event.pointerType !== 'mouse') return;
            this.hovered = false;
            this.schedule();
          });
          on(this.viewport, 'focusin', () => this.stopTimer());
          on(this.viewport, 'focusout', () => {
            queueMicrotask(() => {
              if (this.isConnected) this.schedule();
            });
          });
          on(this.rail, 'pointerdown', () => {
            if (!this.sliderEnabled) return;
            this.pressed = true;
            this.stopTimer();
            clearTimeout(this.settleTimer);
            this.cancelAnimation();
          });
          const release = () => {
            if (!this.pressed) return;
            this.pressed = false;
            this.queueSettle();
          };
          on(window, 'pointerup', release);
          on(window, 'pointercancel', release);
          on(this.rail, 'wheel', () => {
            if (!this.sliderEnabled) return;
            this.stopTimer();
            this.cancelAnimation();
            this.queueSettle();
          });
          on(this.rail, 'scroll', () => {
            if (!this.sliderEnabled || this.animating || this.building || this.count < 2) return;
            if (Math.abs(this.rail.scrollLeft - this.position(this.index)) < 1) return;
            this.stopTimer();
            this.queueSettle();
          });
          on(this.rail, 'keydown', event => {
            if (!this.sliderEnabled) return;
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          });
          on(document, 'visibilitychange', () => this.schedule());
          on(this.mobile, 'change', () => this.build());
          on(this.reducedMotion, 'change', () => this.schedule());
          this.resize = new ResizeObserver(() => {
            const width = this.rail.clientWidth;
            if (width === this.lastWidth) return;
            this.lastWidth = width;
            this.build();
          });
          this.resize.observe(this.rail);
          this.build();
        }
        build() {
          this.sliderEnabled = this.mobile.matches
            ? this.dataset.sliderMobile !== 'false'
            : this.dataset.sliderDesktop !== 'false';
          this.stopTimer();
          this.cancelAnimation();
          clearTimeout(this.settleTimer);
          this.building = true;
          this.rail.querySelectorAll('[data-copy]').forEach(el => el.remove());
          this.rail.classList.toggle('featured__rail--single', this.sliderEnabled && this.count < 2);
          if (this.prev) this.prev.hidden = this.mobile.matches || !this.sliderEnabled || this.count < 2;
          if (this.next) this.next.hidden = this.mobile.matches || !this.sliderEnabled || this.count < 2;
          if (this.sliderEnabled) {
            this.rail.setAttribute('tabindex', '0');
          } else {
            this.rail.removeAttribute('tabindex');
            this.rail.scrollLeft = 0;
            this.viewport.style.removeProperty('--arrow-top');
            this.pressed = false;
            this.building = false;
            return;
          }
          if (!this.count || !this.rail.clientWidth) {
            this.building = false;
            return;
          }
          const cardWidth = this.originals[0].getBoundingClientRect().width;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          this.step = cardWidth + gap;
          const visibleCards = this.mobile.matches ? 2 : Math.max(1, Math.floor((this.rail.clientWidth + gap) / this.step));
          this.centerOffset = (this.rail.clientWidth - (visibleCards * cardWidth + (visibleCards - 1) * gap)) / 2;
          const image = this.originals[0].querySelector('.featured__image');
          this.viewport.style.setProperty(
            '--arrow-top',
            image.getBoundingClientRect().height / 2 + 'px'
          );
          if (this.count < 2) {
            this.building = false;
            return;
          }
          const cycles = Math.ceil(
            (this.rail.clientWidth / this.step + 2) / this.count
          );
          this.copyCount = cycles * this.count;
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          for (let i = 0; i < this.copyCount; i++) {
            before.append(this.copy(this.originals[i % this.count]));
            after.append(this.copy(this.originals[i % this.count]));
          }
          this.rail.prepend(before);
          this.rail.append(after);
          this.index = ((this.index % this.count) + this.count) % this.count;
          this.rail.scrollLeft = this.position(this.index);
          this.building = false;
          this.schedule();
        }
        copy(original) {
          const clone = original.cloneNode(true);
          clone.removeAttribute('data-original');
          clone.setAttribute('data-copy', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, [tabindex]').forEach(el => {
            el.setAttribute('tabindex', '-1');
          });
          return clone;
        }
        position(index) {
          return (this.copyCount + index) * this.step - this.centerOffset;
        }
        nearestIndex() {
          return Math.round(
            (this.rail.scrollLeft + this.centerOffset) / this.step
          ) - this.copyCount;
        }
        move(direction) {
          if (!this.sliderEnabled || this.count < 2 || this.animating) return;
          this.stopTimer();
          clearTimeout(this.settleTimer);
          this.animateTo(this.nearestIndex() + direction);
        }
        queueSettle() {
          if (!this.sliderEnabled) return;
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            if (this.pressed || this.animating || this.count < 2) return;
            this.animateTo(this.nearestIndex());
          }, 160);
        }
        animateTo(index) {
          if (!this.sliderEnabled) return;
          this.cancelAnimation();
          this.stopTimer();
          const start = this.rail.scrollLeft;
          const end = this.position(index);
          const distance = end - start;
          const duration = Math.max(200, Number(this.dataset.duration) || 500);
          const started = performance.now();
          this.animating = true;
          const finish = () => {
            this.index = ((index % this.count) + this.count) % this.count;
            this.rail.scrollLeft = this.position(this.index);
            this.animationFrame = requestAnimationFrame(() => {
              this.animationFrame = requestAnimationFrame(() => {
                this.animating = false;
                this.schedule();
              });
            });
          };
          if (Math.abs(distance) < 1) {
            finish();
            return;
          }
          const tick = now => {
            const progress = Math.min(1, (now - started) / duration);
            const eased = 1 - Math.pow(1 - progress, 3);
            this.rail.scrollLeft = start + distance * eased;
            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(tick);
            } else {
              finish();
            }
          };
          this.animationFrame = requestAnimationFrame(tick);
        }
        cancelAnimation() {
          cancelAnimationFrame(this.animationFrame);
          this.animating = false;
        }
        stopTimer() {
          clearTimeout(this.autoplayTimer);
        }
        schedule() {
          this.stopTimer();
          if (!this.sliderEnabled) return;
          const enabled = this.mobile.matches
            ? this.dataset.mobile === 'true'
            : this.dataset.desktop === 'true';
          const focused = this.viewport.contains(document.activeElement);
          if (
            !this.isConnected ||
            !enabled ||
            this.count < 2 ||
            this.hovered ||
            this.pressed ||
            this.animating ||
            focused ||
            document.hidden
          ) return;
          const delay = Math.max(2, Number(this.dataset.interval) || 5) * 1000;
          this.autoplayTimer = setTimeout(() => this.move(1), delay);
        }
        disconnectedCallback() {
          cancelAnimationFrame(this.startFrame);
          this.cancelAnimation();
          this.stopTimer();
          clearTimeout(this.settleTimer);
          this.abort?.abort();
          this.resize?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["discover-within-budget"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('minumjek-budget-finder')) {
  customElements.define('minumjek-budget-finder', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      this.version = 0;
      this.results = this.querySelector('[data-results]');
      this.status = this.querySelector('[data-status]');
      this.viewAll = this.querySelector('[data-view-all]');
      this.selection = this.querySelector('[data-selection]');
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-budget],button[data-category]');
        if (!button || !this.contains(button)) return;
        const selector = button.hasAttribute('data-budget') ? '[data-budget]' : '[data-category]';
        this.querySelectorAll(selector).forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.load();
      }, { signal: this.lifecycle.signal });
      this.load();
    }
    selectedURL() {
      const budget = this.querySelector('[data-budget][aria-pressed="true"]');
      const category = this.querySelector('[data-category][aria-pressed="true"]');
      const url = new URL(category?.dataset.url || this.dataset.source, location.origin);
      url.search = '';
      url.hash = '';
      url.searchParams.set('filter.v.price.gte', budget?.dataset.min || '0');
      if (Number(budget?.dataset.max) > 0) url.searchParams.set('filter.v.price.lte', budget.dataset.max);
      url.searchParams.set('filter.v.availability', '1');
      return url;
    }
    async load() {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      const version = ++this.version;
      const url = this.selectedURL();
      const budgetLabel = this.querySelector('[data-budget][aria-pressed="true"]')?.textContent.trim() || '';
      const categoryLabel = this.querySelector('[data-category][aria-pressed="true"]')?.textContent.trim() || '';
      this.selection.textContent = [budgetLabel, categoryLabel].filter(Boolean).join(' · ');
      this.viewAll.href = url.href;
      this.status.textContent = this.dataset.loading;
      this.results.replaceChildren();
      this.results.setAttribute('aria-busy', 'true');
      url.searchParams.set('section_id', 'minumjek-budget-results');
      try {
        const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Budget results request failed');
        const html = await response.text();
        if (version !== this.version || !this.isConnected) return;
        const document = new DOMParser().parseFromString(html, 'text/html');
        const fragment = document.querySelector('[data-budget-fragment]');
        if (!fragment || fragment.dataset.priceReady !== 'true') throw new Error('Enable Price filter in Shopify Search & Discovery and check the helper section');
        const minCents = Number(url.searchParams.get('filter.v.price.gte')) * 100;
        const max = url.searchParams.get('filter.v.price.lte');
        if (Number(fragment.dataset.minimum) !== minCents || (max !== null && Number(fragment.dataset.maximum) !== Number(max) * 100)) throw new Error('Price filter was not applied');
        this.results.append(...Array.from(fragment.childNodes));
        this.status.textContent = this.results.querySelector('[data-budget-product]') ? '' : this.dataset.empty;
      } catch (error) {
        if (error.name === 'AbortError' || version !== this.version || !this.isConnected) return;
        this.results.replaceChildren();
        this.status.textContent = this.dataset.error;
        console.warn('[Minumjek budget finder]', error);
      } finally {
        if (version === this.version && this.isConnected) this.results.setAttribute('aria-busy', 'false');
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.lifecycle?.abort();
      this.request?.abort();
      this.version = (this.version || 0) + 1;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
